import { deepMerge } from 'js/utils/Utils'

const defaults = {
  $names: {
    target: '[data-clone]',
    item: '[data-clone-i]',
  },
  dataNames: {
    hasAriaHidden: 'hasAriaHidden',
    cloneTimes: 'cloneTimes',
  },
}

export default class ElementClone {
  constructor(options = {}) {
    this.$contentRoot = document
    this.$targetAll = []

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()

    if (this.$targetAll.length) {
      this._appendClone()
    }
  }
  // destroy(){}

  _set$() {
    this.$targetAll = this.$contentRoot.querySelectorAll(this.$names.target)
  }

  _appendClone() {
    this.$targetAll.forEach(($target) => {
      const data = $target.dataset
      const hasAriaHidden = data[this.dataNames.hasAriaHidden]
      const $item = $target.querySelector(this.$names.item)
      const cloneTimes = parseInt(data[this.dataNames.cloneTimes]) || 1
      for (let i = 0; i < cloneTimes; i++) {
        if ($item) {
          const $clone = $item.cloneNode(true)

          if (hasAriaHidden !== 'false' && hasAriaHidden !== '-1') {
            $clone.setAttribute('aria-hidden', 'true')
          }

          $target.appendChild($clone)
        }
      }
    })
  }
}